import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import LegendContent from "../utils/legend-content.jsx";
import {getDateRangeSortValue} from "../utils/vehicle-passages-search-utils.jsx";
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";

const PlateAnalysisContent = ({ payload }) => {
    const data = payload?.plateAnalysis;

    useEffect(() => {
        if (!data) return null;
        const values = [];

        data.forEach((element) => {
            const details = JSON.parse(element.details ?? "[]");

            details.forEach((detail) => {
                values.push([
                    element.plate,
                    element.count_search,
                    element.last_search,
                    element.user_name,
                    detail.date_search,
                    detail.similar_plate === "true" ? "Sim" : "Não",
                    detail.correspondent_plate === "true" ? "Sim" : "Não",
                    detail.date_range,
                    detail.auto_search === "true" ? "Sim" : "Não"
                ]);
            });
        });

        ReportUtils.createExportableTable(["Placa pesquisada", "Quantidade de pesquisas", "Última pesquisa", "Agente", "D/H de pesquisa", "Caracteres similares", "Placas correspondentes", "Intervalo de tempo", "Auto pesquisa"], values, 'Passagens (por placa)');

    }, [data]);

    if (!data) return null;

    return (
        <>
            <table id="passage-plate-data" className="table report-table" sheet-name="Passagens (por placa)">
                <tbody className="bg-white">

                { data.map((element, index) => {
                    const details = JSON.parse(element.details ?? "[]");
                    const { order, handleSort, sortedData, getIcon } = tableSortHeader(details, {date_range: (row) => getDateRangeSortValue(row)});

                    return (
                        <React.Fragment key={index}>

                            <tr className="details-row border-y border-[#d8d8d8] text-center">
                                <td colSpan={2} className="px-2 py-2 w-[33%]">
                                    <span>Placa pesquisada:</span> <span className={'font-bold'}>{element.plate}</span>
                                </td>

                                <td colSpan={2} className="px-2 py-2 w-[33%]">
                                    <span>Quantidade de pesquisas</span>: <span className={'font-bold'}>{element.count_search}</span>
                                </td>

                                <td colSpan={3} className="px-2 py-2 w-[33%]">
                                    <span>Última pesquisa:</span> <span className={'font-bold'}>{element.last_search}</span>
                                </td>
                            </tr>

                            <tr>
                                <td colSpan={7} className="py-2">
                                    <table className="table max-w-[95%] mx-auto">
                                        <tbody>

                                        <tr className="!bg-[#f6f6f6] text-left">
                                            <th onClick={() => handleSort('user_name')} style={{ cursor: 'pointer', width: '18%' }}>Agente {getIcon(order, 'user_name')}</th>
                                            <th onClick={() => handleSort('date_search')} style={{ cursor: 'pointer', width: '15%' }}>D/H de pesquisa {getIcon(order, 'date_search')}</th>
                                            <th onClick={() => handleSort('similar_plate')} style={{ cursor: 'pointer', width: '10%' }}>Caracteres similares {getIcon(order, 'similar_plate')}</th>
                                            <th onClick={() => handleSort('correspondent_plate')} style={{ cursor: 'pointer', width: '10%' }}>Placas correspondentes {getIcon(order, 'correspondent_plate')}</th>
                                            <th onClick={() => handleSort('date_range')} style={{ cursor: 'pointer', width: '30%' }}>Intervalo de tempo {getIcon(order, 'date_range')}</th>
                                            <th onClick={() => handleSort('auto_search')} style={{ cursor: 'pointer', width: '10%' }}>Auto pesquisa {getIcon(order, 'auto_search')}</th>
                                        </tr>

                                        { sortedData.map((detail, detailIndex) => (
                                            <tr key={`${index}-${detailIndex}`} className="table-break-word">
                                                <td className={'w-[18%]'}>{element.user_name}</td>
                                                <td className={'w-[15%]'}>{detail.date_search}</td>
                                                <td className={'w-[10%]'}>{detail.similar_plate === "true" ? "Sim" : "Não"}</td>
                                                <td className={'w-[10%]'}>{detail.correspondent_plate === "true" ? "Sim" : "Não"}</td>
                                                <td className={'w-[30%]'}>{detail.date_range}</td>
                                                <td className={'w-[10%]'}>{detail.auto_search === "true" ? "Sim" : "Não"}</td>
                                            </tr>
                                        ))}

                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                        </React.Fragment>
                    );
                })}
                </tbody>
            </table>

            <LegendContent/>
        </>
    );
};

export default PlateAnalysisContent;